import { Icon, IconProps } from "@clearabee/ui-library-native";
import React from "react";

export const CompleteIcon = ({ size }: IconProps): React.ReactElement => {
  return (
    <Icon viewBox="0 0 36 27" size={size}>
      <g fill="#FFFFFF" transform="translate(-1771 -931)">
        <path d="M1806.45 931.521a1.964 1.964 0 00-2.663-.002l-23.676 22.257-5.96-5.13c-.768-.658-1.957-.608-2.658.114a1.702 1.702 0 00.12 2.506l7.286 6.27c.114.099.248.153.376.218.07.038.132.093.206.12.221.082.454.126.688.126.482 0 .964-.173 1.33-.518l24.949-23.453a1.702 1.702 0 00.002-2.508" />
      </g>
    </Icon>
  );
};
